import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router';
import { Provider } from 'react-redux';
import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';

import getRoutes from './routes';
import env from './config/environment';
import store, { historySyncWithStore } from './store';
import ConnectedIntlProvider from './components/common/Intl/ConnectedIntlProvider';

import { defaultLocale, initLocales } from './locale';
import { setCookie } from 'ks-client-admin/utils/cookie';
import 'semantic-ui-css/semantic.min.css';
import './deps/semantic/dist/semantic.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import './index.css';
import initReactFastclick from 'react-fastclick';

import configFile from './config';
import Raven from 'raven-js';

initLocales();

const environment = env();
const config = configFile[environment];

initReactFastclick();

function captureNetworkRequest(e) {
  var capture_resource = performance.getEntriesByType("resource");
  for (var i = 0; i < capture_resource.length; i++) {
    const resourceName = capture_resource[i].name;
    if (resourceName.match(/main.*js/) !== null || resourceName.indexOf('bundle') > -1) {
      return capture_resource[i];
    }
  }
}

const sentryDSN = (environment === 'release')
  ? process.env.REACT_APP_SENTRY_DSN_PROD || 'https://f9967cc7015d427e9e61f2b36a7c27dd@o126838.ingest.sentry.io/279671'
  : process.env.REACT_APP_SENTRY_DSN_DEV || 'https://c13fe129af824604bfe5bd5ad5f0277b@o126838.ingest.sentry.io/5637036';

Raven
  .config(sentryDSN)
  .install();

const navConnection = navigator.connection
  || navigator.mozConnection
  || navigator.webkitConnection
  || { rtt: 'network_information_api_not_supported' };

const connectionInfo = {
  rtt: navConnection.rtt,
  downlink: navConnection.downlink,
  effectiveType: navConnection.effectiveType,
};

const cnrOfMainBundle = captureNetworkRequest();

Raven.setExtraContext({
  connection: connectionInfo,
  mainBundleStats: cnrOfMainBundle,
});

// =========== For semantic ui ==============
window.$ = window.jQuery = require('jquery');
require('./deps/semantic/dist/semantic.min.js');
require('jQuery-Scanner-Detection');
// ==========================================

if (environment === 'development') {
  if (config.accessToken) setCookie('ks-app-token-admin', config.accessToken);
}

moment.locale(defaultLocale);
momentLocalizer(moment); // for react-widgets localization

const routes = getRoutes();

const createRouter = (store, history, routes) => {
  return (
    <Provider store={store}>
      <ConnectedIntlProvider store={store}>
          <Router history={history} routes={routes} />
      </ConnectedIntlProvider>
    </Provider>
  );
};

Raven.context(() => {
  const router = createRouter(store, historySyncWithStore, routes);
  ReactDOM.render(router, document.getElementById('root'));
});
